import * as React from 'react'
import {forwardRef} from 'react'
import {cva, type VariantProps} from 'class-variance-authority'
import {cn} from "../lib/fns";
import {LoadingOutlined} from "../assets/svgs/LoadingOutlined";

const buttonVariants = cva("inline-flex items-center justify-center gap-2 whitespace-nowrap transition-all disabled:pointer-events-none disabled:text-neutral-400 outline-none", {
  variants: {
    variant: {
      default: 'border bg-white shadow-xs hover:bg-accent hover:opacity-50 disabled:bg-neutral-200',
      primary: 'bg-primary text-white shadow-xs hover:bg-purple disabled:bg-neutral-100',
      danger: 'bg-danger text-whiter shadow-xs hover:opacity-50 disabled:bg-neutral-100',
      dark: 'bg-neutral-900 text-white shadow-xs hover:bg-neutral-700 disabled:bg-neutral-100',
      secondary: 'bg-white text-primary shadow-xs hover:opacity-50 disabled:bg-neutral-100',
      text: 'bg-transparent text-neutral-600 hover:text-neutral-500 hover:opacity-50',
      link: 'text-primary underline-offset-4 hover:underline',
    }, size: {
      xs: 'h-7 py-1 px-2 text-sm rounded gap-1.5',
      sm: 'h-8 py-2 px-4 text-sm gap-1.5',
      default: 'h-10 p-2 text-sm',
      lg: 'h-12 p-4 text-sm rounded-md',
      icon: 'p-1',
    },
  }, defaultVariants: {
    variant: 'default', size: 'default',
  },
},)

interface Props extends React.ComponentProps<'button'>, VariantProps<typeof buttonVariants> {
  innerClassName?: string;
  asChild?: boolean;
  loading?: boolean
}

const Button = forwardRef<HTMLButtonElement, Props>(({
                                                className,
                                                innerClassName,
                                                variant,
                                                size,
                                                children,
                                                loading = false,
                                                asChild = false,
                                                ...props
                                              }: Props, ref) => {
  
  return (<button
    ref={ref}
    data-slot="button"
    className={cn(buttonVariants({variant, size, className}))}
    {...props}
    children={<>{loading && <LoadingOutlined className={"animate-spin"} />}
      <div
        className={cn(innerClassName, "w-full inline-flex items-center justify-center gap-2 truncate")}>{children}</div>
    </>}
  />)
});

export {Button, buttonVariants}
